var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"ipsTip",staticClass:"ips-tooltip",attrs:{"data-bs-toggle":"tooltip","title":_vm.tooltip,"data-bs-container":"body"}},[_vm._t("tip",null,{"hide":_vm.hide,"toggle":_vm.toggleEnabled,"destroy":_vm.destroy})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }